




















import Vue from 'vue'
import { Component, Prop, Emit } from 'vue-property-decorator'
@Component({})
export default class AppSwitcher extends Vue {
  @Prop({ type: Number }) readonly value!: number
  @Prop({ type: Array }) readonly options!: string[]
  @Prop({ type: Boolean }) readonly disable!: boolean
  @Prop({ type: String }) readonly width!: string

  handleClick (i: number) {
    if (this.value === i || this.disable) {
      return
    }
    this.onClick(i)
  }

  @Emit('input')
  onClick (i: number) {
    this.changeHandler()
  }

  @Emit('change')
  changeHandler () {
    return {
      index: this.value,
      option: this.options[this.value]
    }
  }
}
